import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideClientHydration, withNoIncrementalHydration } from "@angular/platform-browser";
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  withXhr,
} from "@angular/common/http";
import { provideRouter, withPreloading } from "@angular/router";
import { AuthModule } from "@auth0/auth0-angular";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { GoogleMapsModule } from "@angular/google-maps";

import { routes } from "./app.routes";
import { environment as env } from "../environments/environment";

import { MapService } from "./services/map/map.service";
import { ExportService } from "./services/export/export.service";
import { AnswerDataService } from "./services/answer-data/answer-data.service";
import { BaseApiService, AuthInterceptor } from "./services/base/base-api.service";
import { AuthHttpInterceptor } from "@auth0/auth0-angular";
import { WarmUpService } from "./services/warm-up/warm-up.service";
import { IdlePreloadingStrategy } from "./services/preloading/idle-preloading-strategy";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withPreloading(IdlePreloadingStrategy)),
    provideClientHydration(withNoIncrementalHydration()),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    MapService,
    ExportService,
    BaseApiService,
    AnswerDataService,
    WarmUpService,
    importProvidersFrom(
      NgbModule,
      GoogleMapsModule,
      AuthModule.forRoot({
        domain: env.auth.domain,
        clientId: env.auth.clientId,
        authorizationParams: {
          redirect_uri: env.auth.redirectUri,
          audience: env.auth.audience,
        },
        errorPath: env.auth.errorPath,
        httpInterceptor: {
          allowedList: env.httpInterceptor.allowedList,
        },
        cacheLocation: "localstorage",
      }),
    ),
  ],
};
